import React, { useEffect, useState, useRef } from 'react';
import { fetchUsers, setearTotalUsuariosActivos } from '../../../reducer/users-reducers';
import { connect } from 'react-redux';
import { Container, Table } from 'reactstrap';
import { user, filtros } from '../../../types/general-types';
import '../../../sass/users.scss';
import { insertDeactivedAtDate } from '../../../api/users';
import { getCurrentToken } from '../../../reducer/store';
import UserRow from './UserRow';
import HeadRow from './HeadRow';
import UsersFilter from './UsersFilter';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSadTear } from '@fortawesome/free-solid-svg-icons';
import TotalUsers from './TotalUsers';
interface configObject {
  usersReducer: {
    users: user[];
    filtros:filtros;
  };
}

type userProps = {
  fetchUsers: (offset: number, apellido?:string, nombre?:string, idNumero?:string, email?:string) => void;
  users: user[],
  filtros:filtros,
  setearTotalUsuariosActivos: () => void
}

const Users = (props: userProps) => {
  const { fetchUsers, users, filtros, setearTotalUsuariosActivos } = props;
  const [activo, setactivo] = useState<boolean[] | null>(null);
  const [paginado, setpaginado] = useState<number>(0);
  const usersTableWrapperRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleScroll = () => {
      const usersTableWrapper = usersTableWrapperRef.current;
      if (usersTableWrapper && usersTableWrapper.scrollTop + usersTableWrapper.clientHeight === usersTableWrapper.scrollHeight) {
        setpaginado(paginado + 30)
      }
    };

    const usersTableWrapper = usersTableWrapperRef.current;

    if (usersTableWrapper) {
      usersTableWrapper.addEventListener('scroll', handleScroll);

      return () => {
        usersTableWrapper.removeEventListener('scroll', handleScroll);
      };
    }
  }, [paginado]);

  useEffect(() => {
    if (filtros) {
      const { nombre, apellido, email, idNumero } = filtros;
      fetchUsers(paginado, apellido, nombre, idNumero, email);
    } else {
      fetchUsers(paginado);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchUsers, paginado])

  useEffect(() => {
    if (users) {
      let activos: any = []
      users.forEach((user) => {
        let activo = true;
        if (user.deactivedAt) {
          activo = false;
        }
        activos.push(activo)
      })
      setactivo(activos)
    }

  }, [users])

  useEffect(()=>{
    setpaginado(0);
  },[filtros])

  const activarDesactivarUsuario = async (active: boolean, index: number, id: string) => {
    if (activo !== null && index >= 0 && index < activo.length) {
      const nuevoActivo = [...activo];
      nuevoActivo[index] = !active;
      setactivo(nuevoActivo);
      const token = getCurrentToken();
      let activoFecha;
      active ? activoFecha = new Date() : activoFecha = null;
      const res = await insertDeactivedAtDate(token, id, activoFecha);
      if(res){
        setearTotalUsuariosActivos();
      }
    }
  }

  return (
    <Container className='usuarios'>
      <UsersFilter />
      <TotalUsers />
      <div className='users-table-wrapper' ref={usersTableWrapperRef}>
        <Table>
          <thead>
            <HeadRow />
          </thead>
            {users && activo &&
              <tbody>{users.map((user: user, index: number) => {
                return (<UserRow key={index} user={user} index={index} activo={activo[index]} activarDesactivarUsuario={activarDesactivarUsuario} />)
              })}</tbody>
            }
            {users && users.length === 0 && <tbody><tr><td colSpan={8} className='text-center h2 pt-5 pb-5'> <FontAwesomeIcon icon={faSadTear} /> No hay resultados</td></tr></tbody>}
        </Table>
      </div>
    </Container>
  );
};

const mapStateToProps = (state: configObject) => {
  return {
    users: state.usersReducer.users,
    filtros: state.usersReducer.filtros
  };
};
export default connect(mapStateToProps, {
  fetchUsers,setearTotalUsuariosActivos
})(Users);

